<div class="missing-input-container">
	<ng-content></ng-content>
</div>
